<script>
import { VBtn } from 'vuetify/lib'

import { isDark } from '../vue/color'

export default {
  name: 'BtnGradient',
  status: 'deprecated',
  release: '0.1.0',
  description: 'An extension of the Vuetify button that support gradients.',
  components: {
    VBtn
  },
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    intensity: {
      type: [Number, Array],
      default: 1
    }
  },
  computed: {
    gradient () {
      const shade = Array.isArray(this.intensity) ? this.intensity : [this.intensity, this.intensity]
      return [
        this.$vuetify.theme.themes.light[this.color][shade[0] ? 'lighten' + shade[0] : 'lighten1'],
        this.$vuetify.theme.themes.light[this.color][shade[1] ? 'darken' + shade[1] : 'base']
      ]
    },
    isDark () {
      if (typeof this.$attrs.dark !== 'undefined') {
        return true
      }
      if (typeof this.$attrs.light !== 'undefined') {
        return false
      }
      return isDark(this.color)
    },
    vars () {
      return {
        '--btn-gradient-start': this.gradient[0],
        '--btn-gradient-end': this.gradient[1]
      }
    }
  }
}
</script>

<template>
  <VBtn
    :color="color"
    :dark="isDark"
    :light="!isDark"
    :style="vars"
    v-bind="$attrs"
    class="v-btn--gradient"
  >
    <slot />
  </VBtn>
</template>

<style lang="scss">
.v-btn--gradient {
  background: linear-gradient(to bottom, var(--btn-gradient-start), var(--btn-gradient-end));
}
</style>
